import React from 'react';
import { useSiteMetadata } from '@src/hooks/useSiteMetaData';

interface ImageKitProps {
  image: string;
}

const ImageKit = ({ image }: ImageKitProps) => {
  const { imageKitURL } = useSiteMetadata();

  const defaultURL = "https://ik.imagekit.io/panmac/";

  // Use default URL if imageKitURL is undefined
  const url = imageKitURL ? `${imageKitURL}${image}` : `${defaultURL}${image}`;

  return url;
};

export default ImageKit;